import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import TabsContainer from './components/TabsContainer';
import { useDepotDetalhes } from './hooks';
import styled from 'styled-components';

const DetalhesProgramacao = () => {
  const {
    depot,
    loading,
    deleting,
    showDeleteModal,
    activeTab,
    setActiveTab,
    setShowDeleteModal,
    handleEditar,
    handleVoltar,
    handleExcluir,
    confirmDelete,
  } = useDepotDetalhes();

  if (loading) {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <div
              style={{
                textAlign: 'center',
                padding: '50px',
              }}
            >
              Carregando detalhes da Programação...
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!depot) {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <div
              style={{
                textAlign: 'center',
                padding: '50px',
              }}
            >
              Programação não encontrada
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Início' },
              { name: 'Programação', path: '/pages/containers/programacao' },
              { name: 'Detalhes da Programação' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>Detalhes da Programação</CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading
                    variant="danger"
                    onClick={handleExcluir}
                    loading={deleting ? 'true' : undefined}
                  >
                    Excluir
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>

              <TabsContainer
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                depotId={depot?.Id}
                depot={depot}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        loading={deleting}
      />
    </Container>
  );
};

export default DetalhesProgramacao;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  @media (max-width: 576px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;
